exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#cart[data-v-e1cdfa62]{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50}h1[data-v-e1cdfa62],h2[data-v-e1cdfa62]{font-weight:400}ul[data-v-e1cdfa62]{list-style-type:none;padding:0}li[data-v-e1cdfa62]{display:inline-block;margin:0 10px}a[data-v-e1cdfa62]{color:#42b983}.menu-name[data-v-e1cdfa62]{margin-top:2%;font-size:2em}.bwo-title-inline[data-v-e1cdfa62]{display:inline}.bwo-menu-row[data-v-e1cdfa62]{margin-left:0!important;margin-right:0!important}.item-content[data-v-e1cdfa62]{margin:20px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e1cdfa62","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Cart.vue
// module id = 450
// module chunks = 0